import { z } from 'zod';

export enum CustomerType {
  MOBILITY = 'mobility',
  BESS = 'bess',
  HSS = 'hss',
}

export const CustomerTypeSchema = z.nativeEnum(CustomerType);
